import { toastError } from "@/components/molecules";

export const getErrorMessage = (error: unknown): string => {
  if (!error) return "Oops! Something went wrong.";
  if (typeof error === "string" && error.trim()) return error;

  if (typeof error === "object") {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = error as Record<string, any>;
    const responseData = err.response?.data;
    const data = err.data;

    const candidate =
      err.description ||
      err.translation ||
      err.translationKey ||
      responseData?.description ||
      responseData?.translation ||
      responseData?.translationKey ||
      data?.description ||
      data?.translation ||
      data?.translationKey ||
      err.message ||
      responseData?.message ||
      data?.message ||
      err.errors?.[0]?.description ||
      err.errors?.[0]?.translation ||
      err.errors?.[0]?.message ||
      responseData?.errors?.[0]?.description ||
      responseData?.errors?.[0]?.translation ||
      responseData?.errors?.[0]?.message;

    if (typeof candidate === "string" && candidate.trim()) {
      return candidate;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return "Oops! Something went wrong.";
};

export const handleErrorToast = (
  error: unknown,
  onCloseCallback: () => void,
  title = "Error"
) => {
  const message = getErrorMessage(error);
  toastError(message, onCloseCallback, title);
};
